import React from 'react';
import {connect} from 'react-redux';
import strings from 'utils/strings';
import {DEVELOPMENT, ENVIRONMENT} from 'constants/index';

import {updateObject} from 'utils/reducerUtils';
import AudioPlayer from 'components/AudioPlayer'; 
import * as noTutorialLower from './languages/no-tutorial.js';
import * as nnTutorialLower from './languages/nn-tutorial.js';
import * as noTutorialUpper from './languages/no-tutorial-Upper.js';
import * as nnTutorialUpper from './languages/nn-tutorial-Upper.js';
const tutorialObjLowerGrade = {
	no: noTutorialLower,
	nn: nnTutorialLower,
};
const tutorialObjUpperGrade = {
	no: noTutorialUpper,
	nn: nnTutorialUpper,
};
const TUTORIAL_ASSIGNMENT_COUNT = 2;
const NEXT_STEP_COUNT = TUTORIAL_ASSIGNMENT_COUNT + 1;
const SHOW_OPTIONS_IMMEDIATELY = ENVIRONMENT === DEVELOPMENT;

let count = 1;
let answerArray=[];

class Tutorial extends React.Component {
	constructor(props) {
		super(props);
		

		const grade = Number(props.candidateGrade);
		const tutorialObj = grade < 5 ? tutorialObjLowerGrade : tutorialObjUpperGrade;
		this.tutorial = tutorialObj[strings.getLanguage()];
		this.tutorialAssignment = this.tutorial.tutorialAssignment;
		this.assignments = this.tutorial.assignments;
		this.exampleSound = this.tutorial.exampleSound;
		this.dinTurSound = this.tutorial.dinTurSound;
		this.starterTestenSound = this.tutorial.starterTestenSound;

		const results = {};

		for (const assignment of this.assignments) {
			results[assignment.id] = '';
		}
		this.state = {
			hasPlayedFirstAudio: false,
			results,
			counter: 1,
			selectedItems: [],
			choiceId: null,
			choiceValue: null,
			limit: 6,
			/* hideComment: false, */
			showTestPanel: true,
			nextTutorial: false,
			imageClass:'illustrationItem',
			wrongAnswerDetected:false,
			correctAnswerDetected:false,
			halfAnswerDetected:false,
			showOptions: SHOW_OPTIONS_IMMEDIATELY,
			selectedGroupId:null,
			hoverDisabled: false,
			singleAssignment : {
				1: this.tutorial.assignment1,
				2: this.tutorial.assignment2,
				4: this.tutorial.assignment4,
				5: this.tutorial.assignment5,
			},
			defaultAssignments : {
				1: this.tutorial.assignment1,
				2: this.tutorial.assignment2,
				4: this.tutorial.assignment4,
				5: this.tutorial.assignment5,
			}
		};

		this.audioRefs = {};
	}

	handleImageClick (item, assignmentId) {
		const { answerArray = [] } = this.state;
	  
		if (answerArray.includes(item.word)) {return;}
	  
		const updatedAnswerArray = [...answerArray, item.word];
		item.currentClass = 'illustrationItem__clicked';
		this.setResults(assignmentId, {
		  isCorrect: true, 
		  isAnswered: true,
		  answerArray: updatedAnswerArray
		});
	  

		this.setState({
		  answerArray: updatedAnswerArray
		});
	  }

	  recordAnswerSetSyle(assignment, groupId, range) {
		const { singleAssignment, counter } = this.state;
		const [currentAssignment] = assignment;
		const { choices, order, id } = currentAssignment;
	
		const updateChoiceClass = (groupId, newClass) => {
			for (const choice of choices) {
				for (const group of choice.choiceGroup) {
					if (group.groupId === groupId) {
						group.currentClass = newClass;
						return;
					}
				}
			}
		};
	
		if (order.length >= answerArray.length) {
			for (const choice of choices) {
				for (const group of choice.choiceGroup) {
					if (group.groupId === groupId && !answerArray.includes(group.word)) {
						answerArray.push(group.word);
						group.currentClass = 'illustrationItem__selected';
						break;
					}
				}
			}
	
			if (range < 3) {
				const lastAnswerIndex = answerArray.length - 1;
				const isCorrect = order[lastAnswerIndex] === answerArray[lastAnswerIndex];
	
				if (!isCorrect) {
					answerArray.pop();
					updateChoiceClass(groupId, 'illustrationItem__wrong');
					this.setState({
						wrongAnswerDetected: true,
						selectedGroupId: groupId,
						hoverDisabled: true
					});
				} else {
					updateChoiceClass(groupId, 'illustrationItem__clicked');
					this.setState({
						correctAnswerDetected: true,
						hoverDisabled: true 
					});
					
				}
				singleAssignment[counter] = assignment;
				this.setState({ ...singleAssignment });
				this.setResults(id, { answerArray });
			} else if (order.length === answerArray.length) {
				const { correct, present } = this.compareAnswers(order, answerArray);
	
				if (correct === order.length) {
					choices.forEach(choice => {
						choice.choiceGroup.forEach(group => {
							if (answerArray.includes(group.word)) {
								group.currentClass = 'illustrationItem__clicked';
							}
						});
					});
					this.setState({
						correctAnswerDetected: true,
						hoverDisabled: true,
						singleAssignment
					});
				} else if (correct + present === order.length) {
					this.setState({
						halfAnswerDetected: true,
						hoverDisabled: true
					});
				} else {
					choices.forEach(choice => {
						choice.choiceGroup.forEach(group => {
							if (answerArray.includes(group.word)) {
								group.currentClass = 'illustrationItem__wrong';
							}
						});
					});
					this.setState({
						wrongAnswerDetected: true,
						hoverDisabled: true
					});
				}
	
				singleAssignment[counter] = assignment;
				this.setState({ ...singleAssignment });
			}
			singleAssignment[counter] = assignment;
			this.setState({ ...singleAssignment });
			this.setResults(id, { answerArray });
		}
	}


	compareAnswers(correctAnswer = [], userAnswer = []) {
		return userAnswer.reduce(
		  (result, userItem, index) => {
			const correctItem = correctAnswer[index];
	  
			if (userItem === correctItem) {
			  result.correct++;
			} else if (correctAnswer.includes(userItem)) {
			  result.present++;
			} else {
			  result.incorrect++;
			}
	  
			return result;
		  },
		  { correct: 0, present: 0, incorrect: 0 }
		);
	  }

 preloadImages = (urls = []) => {
  const tasks = urls.map((src) => {
    const img = new Image();
    img.src = src;
    return img.decode?.().catch(() => {}); // ignore decode errors
  });
  return Promise.all(tasks);
};

componentDidMount() {
  this.preloadCurrent();
}

componentDidUpdate(prevProps, prevState) {
  if (prevState.counter !== this.state.counter) this.preloadCurrent();
}

preloadCurrent () {
 if (count < NEXT_STEP_COUNT) {
	 const [assignment] = this.state.singleAssignment[this.state.counter];
  const urls = assignment.choices.flatMap(c => c.choiceGroup.map(g => g.img));
  this.preloadImages(urls);
 }
}


	setResults(id, value) {
		const {results} = this.state;
		this.setState({
			results: updateObject(results, {
				[id]: value,
			}),
			choiceId: id,
			choiceValue: value,
		
		});
		
	}
	updateCount() {
		const {results} = this.state;
		this.setState(
			{
				results: updateObject(results, {
					[this.state.choiceId]: this.state.choiceValue,
				}),
			},
			() => {
				this.setState({
					counter: count,
					/* hideComment: true, */
					showTestPanel: false,
					nextTutorial: true,
					showOptions: SHOW_OPTIONS_IMMEDIATELY,
				});
				this.props.onShowAvatar(true);
			}
		);
	}
	scrollToTop = () => {
		window.scrollTo({
			top: 169,
			behavior: 'smooth',
		});
	};

	render() {
		const {onNextStep} = this.props;

		const {hasPlayedFirstAudio, results,singleAssignment} = this.state;

		const allResultsHasValues = Object.keys(results).every(
			(key) => results[key]
		);

		const isNextButtonVisible = count === NEXT_STEP_COUNT;

		return (
			<div className="lit-test">
				<div className="lit-sprakforstaelse lit-sprakforstaelse__tutorial">
					{count < NEXT_STEP_COUNT && singleAssignment[this.state.counter].map(
						(assignment) => {
							const {id, choices,order} = assignment;
							let partialAnswerFeedback;
							if (order.length>1) {

								partialAnswerFeedback = (
									<>
									<br/>
									<p className="feedback">
										<AudioPlayer
											autoplay
											strokeColor="#f4e807ff" 
										outlineColor="#4f5151ff" 
											inline
											onErrorPlay={() => {
												console.log('Something went wrong');
												this.setState({ showOptions: true });
											}}
											onComplete={() => {
												choices.forEach(choice => {
													choice.choiceGroup.forEach(group => {
														group.currentClass = 'illustrationItem';
				});
			});
			answerArray = [];
			singleAssignment[this.state.counter] = [assignment];
			
			this.setState({
				singleAssignment,
				correctAnswerDetected: false,
				halfAnswerDetected: false,
				hoverDisabled: false
			});
		}}
		ref={(ref) => {
			this.narDuStarterAudioPlayer = ref;
		}}
		refs={this.audioRefs}
		src={assignment.partialAnswerSound}
	/>
	{''}
</p>

									</>
								);
							}
							const wrongAnswerFeedBack = (
								<>
								
								<p className="feedback">
									<span className={'visually-hidden-audio'}>
									<AudioPlayer
										autoplay
										strokeColor="#ed381dff" 
										outlineColor="#4f5151ff" 
										inline
										onErrorPlay={()=>{
											console.log('Something went wrong');
										}}
										onComplete={() => {
											const isMultiChoice = order.length > 1;
										
											if (isMultiChoice) {
												choices.forEach(choice => {
													choice.choiceGroup.forEach(group => {
														group.currentClass = 'illustrationItem';
													});
												});
												answerArray = [];
											} else {
												choices.forEach(choice => {
													choice.choiceGroup.forEach(group => {
														if (group.groupId === this.state.selectedGroupId) {
															group.currentClass = 'illustrationItem';
														}
													});
												});
											}
											singleAssignment[this.state.counter] = [assignment];
											this.setState({
												singleAssignment,
												wrongAnswerDetected: false,
												hoverDisabled: false,
											showOptions: true 
											});
										}} 
										ref={(ref) => {
											this.narDuStarterAudioPlayer = ref;
										}}
										refs={this.audioRefs}
										src={assignment.wrongAnswerSound}
									/>
									</span>
										    
										        <span className="lit-feedback-pill is-wrong" role="status" aria-live="polite" aria-label="Feil" />
										     
								</p>
								</>
							);
							const correctAnswerFeedBack = (
								<>
								<br/>
								
								<p className="feedback">
									<span className={'visually-hidden-audio'}>
									<AudioPlayer
										autoplay
										inline
										strokeColor="#2dfd0dff" 
										outlineColor="#4f5151ff" 
										onErrorPlay={()=>{
											console.log('Something went wrong');
										}}
										 onComplete={() => {
											answerArray=[];
											count = count + 1;
											 this.updateCount(); 
											this.setState({
												correctAnswerDetected:false,
												showOptions:true,
												hoverDisabled: false,
													showOptions: true 
											 });//make false
										}} 
										ref={(ref) => {
											this.narDuStarterAudioPlayer = ref;
										}}
										refs={this.audioRefs}
										src={assignment.rightAnswerSound}
									
									/>
									</span>
									     
										       <span className="lit-feedback-pill is-correct" role="status" aria-live="polite" aria-label="Riktig" />
										    
								</p>
								</>
							);
							
							if (this.state.showTestPanel && count < NEXT_STEP_COUNT) {
								return (
									<div className="lit-illustrations-wrapper" key={id}>
										<div className="lit-single-word">
											<p className="instruction">
												<span className="audio-with-step">
												<AudioPlayer
													inline
													strokeColor="#f9fcfcff" 
													outlineColor="#4f5151ff" 
													
													id={
														singleAssignment[
															count
														].id
													}
													key={
														singleAssignment[
															count
														].id
													}
													autoplay
													onErrorPlay={()=>{
														console.log('Something went wrong');
													}}
													onComplete={()=>{
														this.setState({
															showOptions:true
														});
													}}
													ref={(ref) => {
														this.narDuStarterAudioPlayer = ref;
													}}
													refs={this.audioRefs}
													src={assignment.mainSound}
												/>
												<span
															className="tutorial-step-badge"
															aria-label={`Trinn ${count} av ${TUTORIAL_ASSIGNMENT_COUNT}`}
														>
															<span className="current">
																{count}
															</span>
															<span className="sep">
																av
															</span>
															<span className="total">
																{TUTORIAL_ASSIGNMENT_COUNT}
															</span>
														</span>
													</span>
												
											</p>
										</div>
										<div className="lit-options">
											<div className="lit-words-wrapper" >
											<div className="lit-image-grid">
												{choices.map((choice, i) => {
													
													const {choiceGroup} = choice;
													return (
														// eslint-disable-next-line react/jsx-key
														<div>
											
											{this.state.showOptions && (
												<div className="lit-illustrations-list">
													<br />
												{choiceGroup.map((group)=>{
													const isSelected = answerArray.includes(group.word);
													const selectionIndex = answerArray.indexOf(group.word);
													const idWord =
													i + group.word;
													const {groupId} = group;
													const {currentClass} = group;
													
												return (
													<span
														className="lit-word"
														key={idWord}
													>
														<span className="illustrationItemWrapper">
															
																<img
																onClick={()=>{

																	if (order.length !== answerArray.length && !this.state.wrongAnswerDetected) {
																		
																	this.recordAnswerSetSyle(singleAssignment[this.state.counter],groupId,order.length);
																}
																
																if (order.length<3 && order.length===answerArray.length) {

																	this.setState({correctAnswerDetected:true});
																}
																}}
																className={
																	currentClass + (this.state.hoverDisabled ? ' no-hover' : '')
																  }
																	src={
																		group.img
																	}
																	alt={group.word}
																 />
																 </span>
															
													</span>
												);
												})}
												</div>
											)}
														</div>
												);
												})}
												</div>
												</div>
												</div>
												
										
										{this.state.wrongAnswerDetected && (
											wrongAnswerFeedBack
										)}
										{this.state.correctAnswerDetected && (
											correctAnswerFeedBack
										)}
										{this.state.halfAnswerDetected && (
											partialAnswerFeedback
										)}
	
									</div>
								);
							}
						}
					)}
				</div>
				{isNextButtonVisible && (
					<>
					<br/>
					<p className="feedback">
						<AudioPlayer
							inline
							autoplay
							onErrorPlay={()=>{
								console.log('Something went wrong');
							}}
							ref={(ref) => {
								this.narDuStarterAudioPlayer = ref;
							}}
							refs={this.audioRefs}
							src={this.starterTestenSound}
						/>
						{strings.sprakforstaelseStarterTesten}
					</p>
					</>
				)}
				{isNextButtonVisible && (
					<button
						className="lit-btn bg-primary"
						onClick={() => {
							onNextStep(results);
							this.props.onShowAvatar(false);
						}}
					>
						{strings.startTest}
					</button>
				)}
				{this.state.nextTutorial && count < NEXT_STEP_COUNT && (
					<button
						className="lit-btn bg-primary"
						onClick={() => {
							this.setState({
								showTestPanel: true,
								nextTutorial: false,
								showOptions: SHOW_OPTIONS_IMMEDIATELY,
							});
							this.props.onShowAvatar(false);
						}}
					>
						{'Neste'}
					</button>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {candidateGrade} = state;
	return {
		candidateGrade,
	};
};

export default connect(mapStateToProps)(Tutorial);
